import React from "react";
import Header from "../components/Header";
import LoginSection from "../sections/authentication/LoginSection";
import ForgotPasswordSection from "../sections/authentication/ForgotPasswordSection";

function ForgotPasswordPage() {
  return (
    <div className={ClassName.container}>
      <Header />
      <ForgotPasswordSection />
    </div>
  );
}

export default ForgotPasswordPage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
